export default function HeroSection() {
  return (
    <section className="relative overflow-hidden" style={{ backgroundColor: '#2a4a7c' }}>
      {/* Background image - Slide7.JPG from original */}
      <div className="absolute inset-0">
        <img
                  src="/images/k2.png"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(42,74,124,0.75)' }} />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-12 md:py-20 text-center">
        {/* Script tagline */}
        <p className="font-script text-base md:text-lg text-white/90 mb-4">
          America's One-Stop-Shop for Seafood
        </p>

        {/* Main headline */}
        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white tracking-[0.08em] mb-4">
          FRESH, LOCAL & SUSTAINABLE SEAFOOD
        </h1>

        {/* Subtext */}
        <p className="text-[10px] md:text-xs text-white/80 tracking-[0.25em] uppercase max-w-2xl mx-auto mb-8 md:mb-12 leading-relaxed">
          FKS guarantees the best quality products on the market, while staying committed to a healthy ecosystem.
        </p>

        {/* Bottom tagline */}
        <p className="font-script text-sm md:text-base text-white/80">
          America's One-Stop-Shop for Seafood
        </p>
      </div>
    </section>
  );
}